import Tab from '@/types/Tab'

export default [
	new Tab('failed', {
		to: { name: 'jobs' },
		name: 'Failed jobs',
		exact: true,
		value: '/jobs',
	}),
	new Tab('working', {
		to: { name: 'jobs-working' },
		name: 'Working jobs',
		value: '/jobs/working',
	}),
]
